import { createContext } from "react"
export interface MovePosition {
    x: number,
    y: number,
}
export const MoveContext = createContext<{
    position: MovePosition | null,
    handleChangePosition: (pos: MovePosition | null) => void,
}>({
    position: null,
    handleChangePosition: () => {},
})
export const MoveProvider = MoveContext.Provider
